import {TemplateRef} from '@angular/core';

import {HeaderAlignment} from '@app/shared/models/header-alignment';

export class TableColumn {
  /** Set the column active as highlighted column header */
  public active?: boolean;
  /** Represent the template to show the column content */
  public columnTemplate?: TemplateRef<null>;
  /** Represents the template to show in the tooltip for column content */
  public columnTooltip?: TemplateRef<null>;
  /** Represent the template to show the footer column content */
  public footerTemplate?: TemplateRef<null>;
  /** Represent the template to show the column content */
  public footerTooltip?: TemplateRef<null>;
  /** Set the horizontal alignment for column header */
  public headerAlignment?: HeaderAlignment;
  /** Represents the template to show in the tooltip for column header */
  public headerTooltip?: TemplateRef<null>;
  /** Label to show on UI as column header. */
  public label: string;
  /** Represent the simple Material Tooltip */
  public matTooltipValue?: string;
  /** Name of the column */
  public name: string;
  /** Custom class for column */
  public styleClass?: string;

  public constructor() {
    this.matTooltipValue = null;
    this.name            = null;
    this.label           = null;
    this.active          = false;
    this.headerTooltip   = null;
    this.columnTooltip   = null;
    this.columnTemplate  = null;
    this.styleClass      = null;
    this.headerAlignment = HeaderAlignment.LEFT;
    this.footerTemplate  = null;
    this.footerTooltip   = null;
  }
}
